import { combineReducers } from 'redux';

import tagConstants from '../constants/tag.constant';
import { Tag } from '../py-generated/datalouder/tag/types';

type GetStates = {
  tags?: Tag[];
  stocksByTag?: { [key: string]: Set<string> };
  loading?: boolean;
  error?: Error;
};

const getStockTags: (state: GetStates, action: any) => GetStates = (
  state: GetStates = {},
  action
) => {
  const stocksByTag: { [key: number]: Set<string> } = {};

  switch (action.type) {
    case tagConstants.TAG_REQUEST: {
      return { loading: true };
    }
    case tagConstants.TAG_SUCCESS: {
      for (const tagId in action.stocksByTag) {
        stocksByTag[tagId] = new Set<string>(action.stocksByTag[tagId]);
      }
      return {
        tags: action.tags,
        stocksByTag,
      };
    }
    case tagConstants.TAG_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

const selected = (selectedTagId = '', action) => {
  if (action.type === tagConstants.SELECT_TAG) {
    return action.tagId as string;
  }
  return selectedTagId;
};

const reducer = combineReducers({
  getStockTags,
  selected,
});

export default reducer;
